import { NotificationType } from '@evidentid/tprm-portal-lib/models/notification-configuration';

/**
 * The heading each notification carries on the Email Notifications page.
 *
 * Anything naming a notification to a user reads from here, so a template referenced elsewhere in
 * the product is called the same thing it is called on the page the user is sent to.
 *
 * With producer flow on, the entity and producer versions of the new, expiring and non-compliant
 * emails are edited in tabs inside one card, so their titles name neither audience.
 */
export function getNotificationTypeLabel(type: NotificationType): string {
    switch (type) {
        case NotificationType.newEntity:
            return 'Entity Notification for Profile & Producer Information';
        case NotificationType.new:
            return 'Notification for New Requirements';
        case NotificationType.expiring:
            return 'Notification of Expiring Requirements';
        case NotificationType.nonCompliant:
            return 'Notification of Non-Compliant Requirements';
        case NotificationType.compliant:
            return 'Notification of Compliant Status';
        default:
            // An unrecognised type is still worth naming — the raw value beats an empty row.
            return type;
    }
}
